







































import { Component, Vue, Prop, PropSync } from 'vue-property-decorator';
import { KeysArray } from '@/utils/utils';
import get from 'lodash/get';

@Component({
  i18n: {
    messages: {
      en: {
        result: 'Result',
      },
      nb: {
        result: 'Resultat',
      },
    },
  },
})
export default class SBlender<Item> extends Vue {
  @Prop({ required: true, type: Array }) private items!: Item[];
  @Prop({ required: true, type: Array }) private attributes!: KeysArray<Item>;
  @Prop({ required: true, type: [ String, Function ] }) public printHeadersBy?: ((item: Item) => string) | string;
  @Prop([ String, Function ]) public printAttributesBy?: ((attribute: keyof Item) => string) | string;
  @Prop([ Object ]) public printValuesAs?: { [key: string]: ((item: Item) => string) | string };

  @PropSync('result', { type: Object, default: () => ({}) }) private mergeResult!: Item;

  public mounted() {
    // if there is no merge result, preselect first item
    if (!this.mergeResult) {
      this.mergeResult = this.items.length ? { ...this.items[0] } : {} as Item;
    }
  }

  private pick(attribute: keyof Item, item: Item): void {
    this.mergeResult[attribute] = item[attribute];
  }

  private isSameAsMergeResult(attribute: keyof Item, item: Item): boolean {
    return JSON.stringify(this.mergeResult[attribute]) === JSON.stringify(item[attribute]);
  }

  private printValue(attribute: string, item: Item): string {
    if (this.printValuesAs && this.printValuesAs[attribute]) {
      const printValueAs = this.printValuesAs[attribute];
      if (typeof printValueAs === 'function') {
        return printValueAs(item);
      } else {
        return get(item, printValueAs);
      }
    } else {
      return get(item, attribute);
    }
  }
}
